import * as DropdownMenuPrimitive from "@radix-ui/react-dropdown-menu";
import { type ComponentProps } from "react";

import { MenuItem, type MenuItemProps } from "../menu-item";

export type DropdownMenuCheckboxItemProps = ComponentProps<typeof DropdownMenuPrimitive.CheckboxItem> &
  Pick<MenuItemProps, "shortcut">;

export const CheckboxItem = ({
  ref,
  className,
  children,
  shortcut,
  onSelect,
  ...props
}: DropdownMenuCheckboxItemProps) => (
  <DropdownMenuPrimitive.CheckboxItem
    ref={ref}
    // Ticking keeps the menu open, so several items can be ticked in a row.
    onSelect={event => {
      event.preventDefault();
      onSelect?.(event);
    }}
    {...props}
    asChild
  >
    <MenuItem variant="checkbox" shortcut={shortcut} className={className}>
      {children}
    </MenuItem>
  </DropdownMenuPrimitive.CheckboxItem>
);

CheckboxItem.displayName = DropdownMenuPrimitive.CheckboxItem.displayName;
